import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export function provideAppTranslate() {
  const savedLang =
    typeof localStorage !== 'undefined'
      ? localStorage.getItem('lang') || 'de'
      : 'de';
  return provideTranslateService({
    lang: savedLang,
    fallbackLang: 'de',
    loader: provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
  });
}
